// import React, { useEffect } from "react";

// const MultiAdsDisplay = () => {
//   useEffect(() => {
//     const loadCMPScript = () => {
//       if (!document.getElementById("cmp-script")) {
//         const cmpScript = document.createElement("script");
//         cmpScript.id = "cmp-script";
//         cmpScript.src = "https://fundingchoicesmessages.google.com/i/pub-6213965974675068?ers=1";
//         cmpScript.async = true;

//         cmpScript.onload = () => {
//           window.__tcfapi = window.__tcfapi || function () {};
//           window.__tcfapi("addEventListener", 2, (tcData, success) => {
//             if (success && tcData.eventStatus === "useractioncomplete" && tcData.tcString) {
//               loadAdSenseScript();
//             }
//           });
//         };

//         cmpScript.onerror = () => console.error("CMP script failed to load.");
//         document.head.appendChild(cmpScript);
//       }
//     };

//     const loadAdSenseScript = () => {
//       if (!document.getElementById("adsense-script")) {
//         const script = document.createElement("script");
//         script.id = "adsense-script";
//         script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6213965974675068";
//         script.async = true;
//         script.crossOrigin = "anonymous";
//         script.onload = () => {
//           try {
//             (window.adsbygoogle = window.adsbygoogle || []).push({});
//           } catch (e) {
//             console.error("AdSense push failed:", e);
//           }
//         };
//         script.onerror = () => console.error("AdSense script failed to load.");
//         document.body.appendChild(script);
//       }

//       if (!document.querySelector('meta[name="google-adsense-account"]')) {
//         const meta = document.createElement("meta");
//         meta.name = "google-adsense-account";
//         meta.content = "ca-pub-6213965974675068";
//         document.head.appendChild(meta);
//       }
//     };

//     loadCMPScript();
//   }, []);

//   return (
//     <div>
//       <ins className="adsbygoogle"
//            style={{ display: "block" }}
//            data-ad-client="ca-pub-6213965974675068"
//            data-ad-slot="1234567890" // Replace with your actual slot ID
//            data-ad-format="auto"
//            data-full-width-responsive="true"></ins>
//     </div>
//   );
// };

// export default MultiAdsDisplay;
import React, { useEffect } from "react";

const MultiAdsDisplay = () => {
  useEffect(() => {
    // Load CMP (GDPR Consent)
    const loadCMPScript = () => {
      const existingCMPScript = document.getElementById("cmp-script");
      if (!existingCMPScript) {
        const cmpScript = document.createElement("script");
        cmpScript.id = "cmp-script";
        cmpScript.src =
          "https://fundingchoicesmessages.google.com/i/pub-6213965974675068?ers=1";
        cmpScript.async = true;
        cmpScript.onload = () => {
          window.__tcfapi = window.__tcfapi || function () {};
          window.__tcfapi("addEventListener", 2, (tcData, success) => {
            if (success && tcData.eventStatus === "useractioncomplete") {
              if (tcData.tcString) {
                loadAdSenseScript(); // Load ads after consent
              }
            }
          });
        };
        document.head.appendChild(cmpScript);
      }
    };

    // Load AdSense and push ads
    const loadAdSenseScript = () => {
      if (!document.getElementById("adsense-script")) {
        const script = document.createElement("script");
        script.id = "adsense-script";
        script.src =
          "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        script.async = true;
        script.setAttribute("data-ad-client", "ca-pub-6213965974675068");
        document.head.appendChild(script);
      }

      // Trigger ads render
      setTimeout(() => {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
          console.error("Ads push error", e);
        }
      }, 1000);
    };

    loadCMPScript();
  }, []);

  return (
    <div>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-6213965974675068"
        data-ad-slot="YOUR_AD_SLOT_ID" // <-- Replace this!
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default MultiAdsDisplay;









